// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ku-0";